//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { EthAddr } from '@shared/SchemaTypes'

import { useOtChainState } from '@react/redux/store'

import { theme } from '@react/components/theme'
import { PoolRegistryAbi } from '@shared/Abis'
import { Contract } from 'ethers'
import { RoleEnum } from '@shared/Enums'
import { PoolRegistry } from '@typechain-types/contracts'
import { otAssert } from '@shared/conversions'

export default function AdminPoolRemoveForm(props: { poolAddr: EthAddr }): ReactElement {
  const { poolAddr } = props

  const {
    userConnection: { roleEnum, signer },
    chainConfiguration: { perimeterAddresses },
  } = useOtChainState()

  otAssert(perimeterAddresses, 'perimeterAddresses is not defined, please check your connection to the chain')
  const [step, setStep] = React.useState(0)

  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    borderRadius: '6px',
  }

  const closeModal = () => {
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }

  const poolRemoveActionAsyncFunction = async (): Promise<void> => {
    // Future: Split this into separated components for each role
    // Though this is the same operation for both roles, vanilla OT should only allow PoolAdmin to do this
    // while Lyt should allow ProtocolManager
    if (roleEnum != RoleEnum.POOL_ADMIN && roleEnum != RoleEnum.PROTOCOL_MANAGER) {
      throw new Error('Only pool admin or protocol manager can remove pool')
    }
    const poolRegistryContract = new Contract(
      perimeterAddresses.PoolRegistry,
      PoolRegistryAbi,
      signer
    ) as unknown as PoolRegistry

    const tx = await poolRegistryContract.removePool(poolAddr)
    await tx.wait(1)
    setIsSubmitted(false)
    window.location.href = '/'
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  const poolRemoveAction = (): void => {
    setIsSubmitted(true)
    poolRemoveActionAsyncFunction().catch((e) => {
      console.error(e)
      throw e
    })
  }

  if (step == 0) {
    return (
      <Box
        data-testid={AdminPoolRemoveForm.name}
        px={0}
        py={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
          paddingTop: 4,
        }}
      >
        <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: 'center' }}>
          Remove Pool
        </Typography>
        <Box sx={{ display: 'flex', marginTop: 30, justifyContent: 'space-between', width: '100%' }}>
          <Button sx={{ marginTop: 2 }} onClick={closeModal} variant={'outlined'}>
            <Typography variant={'buttonBold'}>Cancel</Typography>
          </Button>
          <Button
            disabled={isSubmitted}
            sx={sx}
            onClick={() => {
              setStep(1)
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Remove Pool ARE YOU REALLY SURE!!</Typography>
          </Button>
        </Box>
      </Box>
    )
  }

  if (step == 1) {
    return (
      <Box
        data-testid={AdminPoolRemoveForm.name}
        px={0}
        py={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
          paddingTop: 4,
        }}
      >
        <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: 'center' }}>
          Remove Pool are you sure?
        </Typography>
        <Box sx={{ display: 'flex', marginTop: 30, justifyContent: 'space-between', width: '100%' }}>
          <Button sx={{ marginTop: 2 }} onClick={closeModal} variant={'outlined'}>
            <Typography variant={'buttonBold'}>Cancel</Typography>
          </Button>
          <Button
            disabled={isSubmitted}
            sx={sx}
            onClick={() => {
              setStep(2)
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Remove Pool ARE YOU Really REALLY SURE!!</Typography>
          </Button>
        </Box>
      </Box>
    )
  }

  if (step == 2) {
    if (isSubmitted) {
      return (
        <Box
          data-testid={AdminPoolRemoveForm.name}
          px={0}
          py={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            paddingTop: 4,
          }}
        >
          <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: 'center' }}>
            Remove Pool In progress, window will close when done
          </Typography>
        </Box>
      )
    }
    return (
      <Box
        data-testid={AdminPoolRemoveForm.name}
        px={0}
        py={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
          paddingTop: 4,
        }}
      >
        <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: 'center' }}>
          Remove Pool for real this time
        </Typography>
        <Box sx={{ display: 'flex', marginTop: 30, justifyContent: 'space-between', width: '100%' }}>
          <Button sx={{ marginTop: 2 }} onClick={closeModal} variant={'outlined'}>
            <Typography variant={'buttonBold'}>Cancel</Typography>
          </Button>
          <Button
            disabled={isSubmitted}
            sx={sx}
            onClick={() => {
              poolRemoveAction()
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Remove Pool This is for real this time</Typography>
          </Button>
        </Box>
      </Box>
    )
  }
  return <></>
}
